export default __webpack_public_path__ + "62cf791c8bae70bff13195f39b15da38.png";